import(/* webpackMode: "eager", webpackExports: ["App"] */ "__barrel_optimize__?names=App!=!/app/web/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/web/app/components/antd-locale-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastProvider"] */ "/app/web/app/components/base/toast/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/web/app/components/base/topbar/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/web/app/components/browser-initor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/web/app/components/i18n.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/web/app/components/sentry-initor.tsx");
;
import(/* webpackMode: "eager" */ "/app/web/app/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/app/web/app/styles/markdown.scss");
;
import(/* webpackMode: "eager" */ "/app/web/app/styles/fix.css");
;
import(/* webpackMode: "eager", webpackExports: ["SiteProvider"] */ "/app/web/context/site-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["changeLanguage"] */ "/app/web/i18n/i18next-config.ts");
